// // import Navbar from '../components/Navbar';
// // import Hero from '../components/Hero';
// // import Services from '../components/Services';
// // import Portfolio from '../components/Portfolio';
// // import About from '../components/About';
// // import Testimonials from '../components/Testimonials';
// // import Contact from '../components/Contact';
// // import Footer from '../components/Footer';

// // const Home = () => {
// //   return (
// //     <main className="min-h-screen bg-background">
// //       <Navbar />
// //       <Hero />
// //       <Services />
// //       <Portfolio />
// //       <Testimonials />
// //       <About />
// //       <Contact />
// //       <Footer />
// //     </main>
// //   );
// // };

// // export default Home;




// import Navbar from '../components/Navbar';
// import Hero from '../components/Hero';
// import Services from '../components/Services';
// import Portfolio from '../components/Portfolio';
// import About from '../components/About';
// import Testimonials from '../components/Testimonials';
// import Clients from '../components/Clients';
// import Contact from '../components/Contact';
// import Footer from '../components/Footer';

// const Home = () => {
//   return (
//     <main className="min-h-screen bg-background">
//       <Navbar />
//       <Hero />
//       <Services />
//       <Portfolio />
//       <Testimonials />
//       <Clients />
//       <About />
//       <Contact />
//       <Footer />
//     </main>
//   );
// };

// export default Home;



import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Services from '../components/Services';
import Portfolio from '../components/Portfolio';
import About from '../components/About';
import Testimonials from '../components/Testimonials';
import Clients from '../components/Clients';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <main className="min-h-screen bg-background">
      <Navbar />
      <Hero />
      <About />
      <Services />
      <Portfolio />
      <Testimonials />
      <Clients />
      <Contact />
      <Footer />
    </main>
  );
};

export default Home;